<template>
  <email-form-modal
    :modal-id="modalId"
    :title="terminology.coverageEmailTitle"
    :initial-emails="email ? [email] : null"
    :initial-form="initialForm"
    :request="submitRequest"
    @success="(complianceDocument) => $emit('input', complianceDocument)"
  >
    <template #fields="{ form }">
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="compliance-document-coverage-email-cc_manager">
            <b-form-checkbox
              id="compliance-document-coverage-email-cc_manager"
              v-model="form.cc_manager"
            >
              CC Manager
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </email-form-modal>
</template>

<script>
import complianceDocumentTerminology from '@/utils/complianceDocumentTerminology';
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'ComplianceDocumentCoveragesEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
    email: String,
    cc_manager: Boolean,
  },
  data() {
    return {
      modalId: 'compliance-document-coverage-email-modal',
    };
  },
  methods: {
    submitRequest(payload) {
      return this.$complianceDocumentCoveragesAPI.email(this.value.id, payload);
    },
  },
  computed: {
    terminology() {
      return complianceDocumentTerminology(this.value.document_type);
    },
    initialForm() {
      return {
        cc_manager: this.cc_manager,
      };
    },
  },
};
</script>
